<template>
  <div>
    <!-- 子表按钮 -->
    <div class="uploadBtns" v-if="!allDisabled() && isCanEditDetailInfo">
      <form method="post" id="file" action="" enctype="multipart/form-data" v-if="currentData.id">
        <el-button type="primary" size="mini" class="a-upload">
          <i class="el-icon-upload2"></i>
          <font>上传</font>
          <input :id="'excelFile' + uploadAppName" type="file" multiple name="file" @change="upload" />
        </el-button>
      </form>
      <el-button type="primary" size="mini" class="a-upload" @click="uploadTip" v-else>
        <i class="el-icon-upload2"></i>
        <font>上传</font>
      </el-button>
    </div>
    <div :id="'viewerDom' + element.model" class="viewerDoms" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.5)">
      <div class="imgsItem" v-for="(item,idx) in tableData" :key="idx">
          <img class="imgs" :src="item.webUrl" @click="viewImgs">
          <div class="operationBtns">
            <span style="font-size:13px" class="blue mr10" @click="download(item)">下载</span>
            <span style="font-size:13px" v-if="!allDisabled() && isCanEditDetailInfo" class="blue" @click="del(item)">删除</span>
          </div>
      </div>
    </div>
    <div class="upload-tip" v-if="uploadTipbox">
        <div class="upload-tip-header">
            <div class="upload-tip-header-title">附件上传</div>
        </div>
        <div class="upload-tip-body">
            <div class="upload-tip-body-cell" v-for="(item,index) in uploadprogressList" :key="index">
                <div class="upload-tip-body-cell-icon"><i :class="{'icon-file-text1':item.type == 'docx','icon-picture':item.type == 'image'}"></i></div>
                <div class="upload-tip-body-cell-progress">
                    <div>{{item.name}}</div>
                    <div><el-progress :percentage="uploadprogress" :stroke-width="3" :show-text="false" color="#2362fb"></el-progress></div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
import { Loading } from 'element-ui'

export default {
  name: 'uploadimageComponents',
  props: ['element', "isChild"],
  data() {
    return {
      file_url: Config.dev_url,
      tableData: [],
      viewer:{},
      loading:false,
      uploadprogress:0,
      uploadTipbox:false,
      uploadprogressList:[],
    }
  },
  computed: {
    //当前详情页信息
    detailInfos() {
      return this.$store.state.detailInfo
    },
    //当前登录人信息
    currentuser() {
      return this.$store.state.currentuser
    },
    uploadAppName() {
        if(!!this.element.options.relationApp){
            return this.element.options.relationApp
        }else if (this.element.model.indexOf('enclosure_') !== -1 || !this.element.model) {
            return  this.isChild ? this.element.options.tablename : this.$route.params.app
        } else {
            return this.element.model
        }
    },
    recordid(){
       if(!!this.element.options.identificationField){
          return  this.isChild ? this.currentAppChildRowData[this.element.options.identificationField] : this.detailInfos[this.element.options.identificationField]
       }else{
          return  this.isChild ? this.currentAppChildRowData.id : this.detailInfos.id
       }
    },
    //子表信息
    currentAppChildRowData(){
        return this.$store.state.currentAppChildRowData
    },
    //是否请求子表数据
    isrequestChildTableData(){
        return this.$store.state.isrequestChildTableData
    },
    //子表请求详情数据时请求附件数据
    isrequestChildenclosureForDetail(){
        return this.$store.state.isrequestChildenclosureForDetail
    },
    currentData(){
        return this.isChild ? this.currentAppChildRowData : this.detailInfos
    },
    //是否可编辑主表信息
    isCanEditDetailInfo(){
        return this.$store.state.isCanEditDetailInfo
    },
  },
  methods: {
    allDisabled(){
        if(this.element.options.disabled){
            return true
        }else if(this.permissionSetting(this.element.options.readonlyRoleList,'readonly')){
            return true
        }else if(this.$store.getters.getcustomformDisabled()){
            return true
        }else if(this.componentsIsShow(this.element,this.element.options.disabledCondition)){
            return true
        }else{
            return false
        }
    },
    viewImgs(e){
      if(!!this.element.model){
        var str = '#viewerDom' + this.element.model
        var ViewerDom = document.querySelector(str);
      }else{
        var ViewerDom = document.querySelector('#viewerDom');
      }
      new Viewer(ViewerDom, {
        initialViewIndex: 0,
        button: true, //右上角关闭按钮
        navbar: 2,
        title: 0,
        toolbar: 0,
        keyboard: false,
        toolbar:{
          zoomIn:true,
          zoomOut:true,
          reset:true,
          prev:true,
          play:true,
          next:true,
          rotateLeft:true,
          rotateRight:true,
          flipHorizontal:true,
          flipVertical:true,
        }
      });
    },
    //权限设置方法
    permissionSetting(arr, str) {
      if (!!arr && arr.length != 0) {
        var newArr = [];
        for (var i = 0; i < arr.length; i++) {
          newArr.push(arr[i].name)
        }
        var res = newArr.includes(this.$store.state.currentuser.roleName)
        if (str == 'look') {
          return !res
        } else {
          return res
        }
      } else {
        if (str == 'look') {
          return true
        } else {
          return false
        }
      }
    },
    //组件禁用、隐藏条件解析
    componentsIsShow(element, hideCondition) {
      var str = hideCondition
      if (!!hideCondition) {
        var arr = hideCondition.split('&&')
        var Arr = arr.map((arrItem) => {
          if (arrItem.indexOf('||') !== -1) {
            return arrItem.split("||")
          } else {
            return arrItem
          }
        })
        var newArr = Arr.flat(Infinity)
        newArr.forEach((newArrItem) => {
          if (newArrItem.indexOf('(') !== -1) {
            newArrItem = newArrItem.substr(1, newArrItem.length)
          } else if (newArrItem.indexOf(')') !== -1) {
            newArrItem = newArrItem.substr(0, newArrItem.length - 1)
          } else if (newArrItem.indexOf('!==') !== -1 && newArrItem.indexOf(':') !== -1) {
            if (this.isChild && JSON.stringify(this.currentAppChildRowData) !== "{}") {
              var Detailfiled = newArrItem.substr(1, newArrItem.indexOf('!==') - 1)
              var filedValue = newArrItem.substr(newArrItem.indexOf('!==') + 3, newArrItem.length)
              if (filedValue.indexOf('currentuser:') !== -1) {
                filedValue = filedValue.replace(filedValue, this.currentuser[filedValue.substr(12, filedValue.length)])
              }
              if (this.detailInfos[Detailfiled] != filedValue) {
                str = str.replace(newArrItem, true)
              } else {
                str = str.replace(newArrItem, false)
              }
            } else if (JSON.stringify(this.detailInfos) !== "{}") {
              var Detailfiled = newArrItem.substr(1, newArrItem.indexOf('!==') - 1)
              var filedValue = newArrItem.substr(newArrItem.indexOf('!==') + 3, newArrItem.length)
              if (filedValue.indexOf('currentuser:') !== -1) {
                filedValue = filedValue.replace(filedValue, this.currentuser[filedValue.substr(12, filedValue.length)])
              }
              if (this.detailInfos[Detailfiled] != filedValue) {
                str = str.replace(newArrItem, true)
              } else {
                str = str.replace(newArrItem, false)
              }
            }
          } else if (newArrItem.indexOf(':') !== -1 && newArrItem.indexOf('==') !== -1) {
            if (this.isChild && JSON.stringify(this.currentAppChildRowData) !== "{}") {
              var Detailfiled = newArrItem.substr(1, newArrItem.indexOf('=') - 1)
              var filedValue = newArrItem.substr(newArrItem.indexOf('=') + 2, newArrItem.length)
              if (filedValue.indexOf('currentuser:') !== -1) {
                filedValue = filedValue.replace(filedValue, this.currentuser[filedValue.substr(12, filedValue.length)])
              }
              if (!!this.currentAppChildRowData[Detailfiled] && this.detailInfos[Detailfiled] == filedValue) {
                str = str.replace(newArrItem, true)
              } else {
                str = str.replace(newArrItem, false)
              }
            } else if (JSON.stringify(this.detailInfos) !== "{}") {
              var Detailfiled = newArrItem.substr(1, newArrItem.indexOf('=') - 1)
              var filedValue = newArrItem.substr(newArrItem.indexOf('=') + 2, newArrItem.length)
              if (filedValue.indexOf('currentuser:') !== -1) {
                filedValue = filedValue.replace(filedValue, this.currentuser[filedValue.substr(12, filedValue.length)])
              }
              if (!!this.detailInfos[Detailfiled] && this.detailInfos[Detailfiled] == filedValue) {
                str = str.replace(newArrItem, true)
              } else {
                str = str.replace(newArrItem, false)
              }
            }
          } else if (newArrItem.indexOf(':') !== -1 && newArrItem.indexOf('==') == -1) {
            if (this.isChild && JSON.stringify(this.currentAppChildRowData) !== "{}") {
              var Detailfiled = newArrItem.substr(newArrItem.indexOf(':') + 1, newArrItem.length)
              var replaceStr = newArrItem.substr(newArrItem.indexOf(':'), newArrItem.length)
              if (!!this.currentAppChildRowData[Detailfiled]) {
                str = str.replace(replaceStr, true)
              } else {
                str = str.replace(replaceStr, false)
              }
            } else if (JSON.stringify(this.detailInfos) !== "{}") {
              var Detailfiled = newArrItem.substr(newArrItem.indexOf(':') + 1, newArrItem.length)
              var replaceStr = newArrItem.substr(newArrItem.indexOf(':'), newArrItem.length)
              if (!!this.detailInfos[Detailfiled]) {
                str = str.replace(replaceStr, true)
              } else {
                str = str.replace(replaceStr, false)
              }
            }
          }
        })
        if (str.indexOf(':') == -1) {
          return eval(str)
        }
      } else {
        return false
      }
    },
    uploadTip() {
      if (this.isChild) {
        if (!this.currentAppChildRowData.id) {
          this.$message.warning('请先保存当前数据之后再上传')
        }
      } else {
        if (!this.detailInfos.id) {
          this.$message.warning('请先保存当前数据之后再上传')
        }
      }
    },
    //上传
    upload() {
      this.uploadprogressList = []
      if (document.getElementById('excelFile' + this.uploadAppName).value == '') {
        return;
      }
      var formData = new FormData();
      for (var i = 0; i < document.getElementById('excelFile' + this.uploadAppName).files.length; i++) {
        var obj = {
            name:document.getElementById('excelFile' + this.uploadAppName).files[i].name,
            type: document.getElementById('excelFile' + this.uploadAppName).files[i].type.indexOf("image") != -1 ? 'image' : 'docx'
        }
        this.uploadprogressList.push(obj)
        formData.append('fileList', document.getElementById('excelFile' + this.uploadAppName).files[i]);
      }
      var str = this.uploadprogressList.every((item)=>{
          return item.type == 'image'
      })
      if(!str){
          this.$message.warning("上传错误，只能上传图片")
          return
      }
      // 上传地址   app   appid  当前数据的id
      if (this.isChild) {
        var url = this.file_url + '/file-center/file/uploads?appname=' + this.uploadAppName
          + '&appid=' + this.$route.query.appid
          + '&recordid=' + this.recordid
          + '&userid=' + this.currentuser.id
          + '&username=' + this.currentuser.username
          + '&deptid=' + this.currentuser.deptcode
          + '&deptfullname=' + this.currentuser.deptName
          + '&encryption=0'
      } else {
        var url = this.file_url + '/file-center/file/uploads?appname=' + this.uploadAppName
          + '&appid=' + this.$route.query.appid
          + '&recordid=' + this.recordid
          + '&userid=' + this.currentuser.id
          + '&username=' + this.currentuser.username
          + '&deptid=' + this.currentuser.deptcode
          + '&deptfullname=' + this.currentuser.deptName
          + '&encryption=0'
      }
      var config = {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: function (e) {
            if (e.lengthComputable) {
              var rate  = e.loaded / e.total; //已上传的比例
              if (rate < 1) {
                this.uploadprogress = (rate *100).toFixed(2)
              }
            }
        }
     };
     this.uploadTipbox = true
      this.$axios.post(url, formData).then((res) => {
        this.loading = false
        document.getElementById('excelFile' + this.uploadAppName).value = ''
        if (res.data.code == 0) {
          this.$message({
            message: '文件已成功上传至服务器',
            type: 'success'
          });
          this.getData()
          this.uploadprogress = 100
          setTimeout(()=>{
            this.uploadTipbox = false
            this.uploadprogress = 0
          },1500)
        } else {
          this.uploadTipbox = false
          this.uploadprogress = 0
          this.$message({
            message: res.data.message,
            type: 'warning'
          });
        }
      }).catch((err)=>{
          this.$message.warning(err.msg)
          this.uploadTipbox = false
          this.uploadprogress = 0
      })
    },
    //下载
    download(row) {
      var url = row.filepath
        + '&userid=' + row.userid
        + '&username=' + row.username
        + '&deptid=' + row.deptid
        + '&deptfullname=' + row.deptfullname
        + '&encryption=0'
      var downurl = url + '&access_token=' + this.getCookie("access_token");
      window.open(downurl);
    },
    del(row) {
      var url = this.file_url + '/file-center/file/logicDeleteFile/' + row.fileid;
      this.$confirm("确定删除此数据吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(() => {
        this.$axios.delete(url, {}).then((res) => {
          if (res.data.code == 1) {
            this.$message({ message: '删除成功', type: 'success' });
          } else {
            this.$message({ message: '删除失败', type: 'warning' });
          }
          this.getData();
        }).catch((err) => {
        });
      })
    },
    //获取文件列表
    getData() {
      var url = this.file_url + '/file-center/file/fileList';
      if (!this.recordid) {
        return
      }
      var data = {
        appname: this.uploadAppName,
        recordid: this.recordid,
        page: 1,
        size: 1000,
      }
      this.loading = true
      this.$axios.post(url, data).then((res) => {
        this.tableData = res.data.fileList
        this.$nextTick(()=>{
            this.$store.commit('setisrequestChildTableData',false)
            this.$store.commit('setisrequestChildenclosureForDetail',false)
        })
      }).catch((err) => {
      });
      this.loading = false
    },
  },
  watch: {
      //监听主表选中状态操作完之后初始化
      isrequestChildTableData(val) {
          if(val){
              if(!!this.detailInfos.id){
                  this.getData()
              }else{
                  this.tableData = []
                  this.$nextTick(()=>{
                      this.$store.commit('setisrequestChildTableData',false)
                  })
              }
          }
      },
      //监听子表请求详情数据
      isrequestChildenclosureForDetail(val){
          if(val){
              if(!!this.currentAppChildRowData.id){
                  this.getData()
              }else{
                  this.tableData = []
                  this.$nextTick(()=>{
                      this.$store.commit('setisrequestChildenclosureForDetail',false)
                  })
              }
          }
      }
  }
}
</script>

<style scoped>
.uploadBtns {
  text-align: right;
  margin: 10px;
}
#file button {
  position: relative;
}
.a-upload input {
  position: absolute;
  font-size: 0px;
  font-size: 20px \9;
  left: -15px;
  top: -10px;
  height: 30px;
  opacity: 0;
  filter: alpha(opacity=0);
  cursor: pointer;
  width: 70px;
  cursor: pointer;
}
.upload-btn {
  color: #fff;
  background-color: #286090;
  border-radius: 4px;
  padding: 4px 10px;
  width: 85px;
  height: 34px;
  line-height: 28px;
  border: none;
  cursor: pointer;
}
.viewerDoms{
  width: 100%;
  height: 240px;
  overflow: scroll;
}
.viewerDoms img{
  margin: 10px;
  border: 1px dashed #ccc;
  padding: 10px;
  padding-bottom: 20px;
  border-radius: 10px;
  width: 200px;
  height: 200px;
}
.imgsItem{
   position: relative;
   width: 220px;
   height: 215px;
   float: left;
}
.operationBtns {
  position: absolute;
  right: 20px;
  bottom: 2px;
  font-size: 16px;
  margin: 0 2px;
}
</style>
